/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ReissueOwnerKeyAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ReissueOwnerKeyAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyAuthClusterResponse429ResponseBodyData;

  constructor(
    err: ReissueOwnerKeyAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ReissueOwnerKeyAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ReissueOwnerKeyAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyAuthClusterResponse409ResponseBodyData;

  constructor(
    err: ReissueOwnerKeyAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ReissueOwnerKeyAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ReissueOwnerKeyAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyAuthClusterResponse404ResponseBodyData;

  constructor(
    err: ReissueOwnerKeyAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ReissueOwnerKeyAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ReissueOwnerKeyAuthClusterResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyAuthClusterResponseResponseBodyData;

  constructor(
    err: ReissueOwnerKeyAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ReissueOwnerKeyAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ReissueOwnerKeyAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyAuthClusterResponseBodyData;

  constructor(
    err: ReissueOwnerKeyAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type ReissueOwnerKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ReissueOwnerKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ReissueOwnerKeyResponseBodyData;

  constructor(
    err: ReissueOwnerKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ReissueOwnerKeyResponseBody";
  }
}

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ReissueOwnerKeyAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ReissueOwnerKeyAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ReissueOwnerKeyAuthClusterResponse429ResponseBody
  > = z.instanceof(ReissueOwnerKeyAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ReissueOwnerKeyAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ReissueOwnerKeyAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ReissueOwnerKeyAuthClusterResponse409ResponseBody
  > = z.instanceof(ReissueOwnerKeyAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ReissueOwnerKeyAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ReissueOwnerKeyAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ReissueOwnerKeyAuthClusterResponse404ResponseBody
  > = z.instanceof(ReissueOwnerKeyAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ReissueOwnerKeyAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ReissueOwnerKeyAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ReissueOwnerKeyAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    ReissueOwnerKeyAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ReissueOwnerKeyAuthClusterResponseResponseBody
  > = z.instanceof(ReissueOwnerKeyAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ReissueOwnerKeyAuthClusterResponseBody$inboundSchema: z.ZodType<
  ReissueOwnerKeyAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ReissueOwnerKeyAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ReissueOwnerKeyAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyAuthClusterResponseBody$outboundSchema: z.ZodType<
  ReissueOwnerKeyAuthClusterResponseBody$Outbound,
  z.ZodTypeDef,
  ReissueOwnerKeyAuthClusterResponseBody
> = z.instanceof(ReissueOwnerKeyAuthClusterResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ReissueOwnerKeyResponseBody$inboundSchema: z.ZodType<
  ReissueOwnerKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ReissueOwnerKeyResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ReissueOwnerKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ReissueOwnerKeyResponseBody$outboundSchema: z.ZodType<
  ReissueOwnerKeyResponseBody$Outbound,
  z.ZodTypeDef,
  ReissueOwnerKeyResponseBody
> = z.instanceof(ReissueOwnerKeyResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
